import { render, staticRenderFns } from "./LoanableForm.vue?vue&type=template&id=235ba5c0"
import script from "./LoanableForm.vue?vue&type=script&lang=js"
export * from "./LoanableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports